module.exports = "/_next/static/images/stripe5-54b892707a8d61562d440b0783184eba.png";